import React from "react";
import { Button } from "./ui/button";

export function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <div className="container">
        <a className="navbar-brand fw-bold" href="/">
          eChurch Service
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link active" href="/">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/live">Live Service</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/donate">Donate</a>
            </li>
            <li className="nav-item">
              <Button>Join Now</Button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
